import { Navigate, useSearchParams } from "react-router-dom";

const MODE_PARAM = "mode";

export default function LoginRedirect() {
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect");
  const mode = searchParams.get(MODE_PARAM);
  const nextPath = mode === "signup" ? "/sign-up" : "/sign-in";
  const nextSearch = redirect?.startsWith("/")
    ? `?redirect=${encodeURIComponent(redirect)}`
    : "";

  return <Navigate to={`${nextPath}${nextSearch}`} replace />;
}
